import PropTypes from 'prop-types';

import { ROLE_NAMES } from 'common/Constants';

const PermissionError = ({ contentLines, requiredRoles, title, userRoles }) => (
  <div className="error-page d-flex align-items-center justify-content-center mt-5" id="error-page">
    <div>
      <div className="d-flex justify-content-center mb-2 mt-5">
        <span role="none">
          <img
            alt="logo"
            className="viking-logo"
            src="https://aem-prod-publish.viking.com/content/dam/vikingcruises/en/magnolia-images/logo/VIKING_COLOR.svg"
          />
        </span>
      </div>
      <div className="d-flex justify-content-center align-items-center mt-5 mb-2">
        <div className="row">
          <div className="col-12">
            <div className="h5 pb-3 align-items-center text-center">{title}</div>
            <div className="row no-gutters">
              {contentLines.map((line, index) => (
                <div className="msg-text col-12" key={index}>
                  {(line || '').replace(
                    /{REQUIRED_ROLES}/g,
                    (requiredRoles || []).map((role) => ROLE_NAMES[role] || '').join(', '),
                  )}
                </div>
              ))}
              {userRoles?.length > 0 && (
                <div className="msg-text col-12 mt-3 d-none">
                  {`(Current Roles: ${(userRoles || []).map((role) => ROLE_NAMES[role] || role || '').join(', ')})`}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

PermissionError.propTypes = {
  contentLines: PropTypes.arrayOf(PropTypes.string),
  requiredRoles: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string,
  userRoles: PropTypes.arrayOf(PropTypes.string),
};

PermissionError.defaultProps = {
  contentLines: ['You do not have {REQUIRED_ROLES} role.', 'Please contact your administrator.'],
  requiredRoles: [],
  title: 'CS Admin Unavailable',
  userRoles: [],
};

export default PermissionError;
